import styled from 'styled-components';
import PrescriptionCancelReason from './PrescriptionCancelReason';
import { OrderStatusType } from '@/@types/order';
import { Order } from '@/apis/order/interface';
import PrescriptionDenyConfirmModal from '../../modal/PrescriptionDenyConfirmModal';
import useOrderWaitingPaymentViewModel from '@/hooks/order/useOrderWaitingPaymentViewModel';
import UpdateOrderPriceFormModal from '../../modal/UpdateOrderPriceFormModal';

interface Props {
  order: Order;
}
const OrderWaitingPayment = ({ order }: Props) => {
  const { PrescriptionDenyModal, UpdateOrderPriceModal, ...viewModel } =
    useOrderWaitingPaymentViewModel({
      order
    });
  return (
    <>
      {viewModel.orderViewStatus !== OrderStatusType.PrescriptionDenied ? (
        <>
          <Status>환자가 결제 금액을 확인 중입니다.</Status>
          <ButtonWrapper>
            <Button
              onClick={() =>
                viewModel.onChangeOrderViewStatus(
                  OrderStatusType.PrescriptionDenied
                )
              }>
              조제 거절
            </Button>
            <Button
              primary
              onClick={() => viewModel.onChangeUpdateOrderPriceModal(true)}>
              금액 변경
            </Button>
          </ButtonWrapper>
        </>
      ) : (
        // 조제 거부 사유
        <PrescriptionCancelReason
          orderDenyReasons={viewModel.orderDenyReasons}
          cancelReason={viewModel.cancelReason}
          setCancelReason={viewModel.setCancelReason}
          onSubmitOrderCancelByPharmacy={
            viewModel.onSubmitOrderCancelByPharmacy
          }
          onClickReset={() => {
            viewModel.setCancelReason('');
            viewModel.onChangeOrderViewStatus(OrderStatusType.Ready);
          }}
        />
      )}

      {/* Modal */}
      {/* 가격 재설정 */}
      <UpdateOrderPriceModal clickOverlayToClose={false}>
        <UpdateOrderPriceFormModal
          orderId={order.id}
          onCloseModal={() => viewModel.onChangeUpdateOrderPriceModal(false)}
        />
      </UpdateOrderPriceModal>

      {/* 조제 거부 */}
      <PrescriptionDenyModal clickOverlayToClose={false} thin>
        <PrescriptionDenyConfirmModal
          cancelReason={viewModel.cancelReason}
          onCloseModal={viewModel.onChangePrescriptionDenyModal}
          onSubmitPrescriptionDeny={viewModel.onSubmitPrescriptionDeny}
        />
      </PrescriptionDenyModal>
    </>
  );
};

export default OrderWaitingPayment;

const Status = styled.div`
  margin-bottom: 24px;

  ${({ theme }) => `
    ${theme.DF_TYPOGRAPHY.UI20SB};
    color: ${theme.DF_COLOR.GRAY700};
  `};
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

const Button = styled.button<{ primary?: boolean }>`
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
  border: 1px solid;

  div {
    margin-right: 8px;
  }
  ${({ theme, primary }) => `
    ${theme.DF_TYPOGRAPHY.UI16SB};
    color: ${primary ? theme.DF_COLOR.WHITE : theme.DF_COLOR.GRAY600};
    background: ${primary ? theme.DF_COLOR.PRIMARY600 : theme.DF_COLOR.WHITE};
    border-color: ${
      primary ? theme.DF_COLOR.PRIMARY500 : theme.DF_COLOR.GRAY200
    }};
    
    &:hover:not(:disabled) {
      opacity: 0.7;
    }
  
    :disabled {
      background: ${theme.DF_COLOR.GRAY100};
      border-color: ${theme.DF_COLOR.GRAY100};
      cursor: default;
    }
  `};
`;
